import { wsgSkpApiHeader } from './header'
import { getAccLevelResponse } from './responseHandler'
import { getAccountLevel2Endpoint } from '../firestore/getGdeSkpApiSettings'
import { HTTP_POST } from '../common/appConstants'
import { accountLevel2ReqBody } from './skpApiDataModel'
import { addCache, getCache } from '../firestore/cache'

const accountLevel2Expires = 60 * 60 * 1000
/**
 * 
 * @param {string} system environment info
 * @param {string} accountLevel1Code accountLevel1Code
 * @param {string} accountLevel2Code accountlevel1code
 * @returns {object} response from accountLevel1
 */
export const validateAndGetAccountLevel2 = async (system, accountLevel1Code, accountLevel2Code) => {
  try {
    const result = await Promise.all([
      wsgSkpApiHeader(),
      getAccountLevel2Endpoint()
    ]) 
    const headerResponse = result[0]
    const apiUrl = result[1]
    const requestBody = accountLevel2ReqBody(system, accountLevel1Code, accountLevel2Code)
    const cacheKey = `${system}-${accountLevel1Code}-${accountLevel2Code}`
    const doc = 'validateAndGetAccountLevel2'
    let accountLevel2Response = getCache(doc, cacheKey)
    if (!accountLevel2Response) {
      accountLevel2Response = await getAccLevelResponse(HTTP_POST, apiUrl, requestBody, {}, headerResponse)
      if (accountLevel2Response.success) {
        addCache(doc, cacheKey, accountLevel2Response, accountLevel2Expires)
      }
    }
    return accountLevel2Response
  } catch (error) {
    if (error?.message) {
      return { error: error.message }
    } else {
      return { error: error.errors[0].message ? error.errors[0].message : 'unexpected error occurred' }
    }
  }
}